export enum EKiwifyType {
  STORE = 'STORE',
  ABANDONED_CART = 'ABANDONED_CART',
  PIX = 'PIX',
  BOLETO = 'BOLETO',
  REJECTED_PAYMENT = 'REJECTED_PAYMENT',
}
